import { render, staticRenderFns } from "./ReferentielTiersView.vue?vue&type=template&id=0b5829d2"
import script from "./ReferentielTiersView.vue?vue&type=script&lang=js"
export * from "./ReferentielTiersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports